import { styled, RadioGroup } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const StyledRadioGroup = styled(RadioGroup)(({ theme }) => ({
  gap: theme.spacing(2),
}));
